import { useCounter } from './useCounter';
import { ActionType } from '../redux/actionType';
import { useStickyDiff } from './useStickyDiff';
import { useLoadingOfType, useErrorOfType } from '../api/hooks';
import * as R from 'ramda';


/**
 * A React Hook that keeps a count of successfully returned API actions of the provided types
 *
 * @param actionType - the type of API actions to track for success; with each success, the counter increments by 1
 */
export const useCounterOnAnySuccess = (
  actionType: ActionType,
): [number, () => void] => {
  const [successCount, incrementSuccessCount, resetSuccessCount] = useCounter();

  const loadingMap = useLoadingOfType(actionType);
  const errorMap   = useErrorOfType(actionType);

  useStickyDiff(
    (prev, next) => {
      const returnedReqs = R.difference(Object.keys(prev?.loadingObjs ?? []), Object.keys(next.loadingObjs));

      R.forEach(
        key => {
          if (!R.has(key, next.errorObjs)) {
            incrementSuccessCount();
          }
        },
        returnedReqs,
      );
    },
    {
      loadingObjs: loadingMap,
      errorObjs:   errorMap,
    },
  );

  return [successCount, resetSuccessCount];
};
